import { render, staticRenderFns } from "./ParentInformation.vue?vue&type=template&id=4d46275e&"
import script from "./ParentInformation.vue?vue&type=script&lang=js&"
export * from "./ParentInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports